export const CENTS_IN_RAND = 100;
export const ACTIVE_OPACITY = 0.7;
